"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _calicoUiKit = require("@calico/calico-ui-kit");

var _ref = _react.default.createElement("br", null);

var _ref2 = _react.default.createElement(_calicoUiKit.Icon, {
  icon: "ios-link"
});

var _ref3 = _react.default.createElement(_calicoUiKit.Icon, {
  icon: "ios-clipboard-outline"
});

var Citation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Citation, _React$Component);

  function Citation() {
    (0, _classCallCheck2.default)(this, Citation);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Citation).apply(this, arguments));
  }

  (0, _createClass2.default)(Citation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          citation = _this$props2.citation,
          showCopyCitation = _this$props2.showCopyCitation,
          showCopyUri = _this$props2.showCopyUri,
          showTitle = _this$props2.showTitle,
          showUri = _this$props2.showUri,
          title = _this$props2.title,
          tooltip = _this$props2.tooltip,
          uri = _this$props2.uri;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('citation', className),
        style: style
      }, showTitle && title && _react.default.createElement("span", null, title, _ref), showUri && uri && _react.default.createElement("a", {
        href: uri,
        rel: "noopener noreferrer",
        target: "__blank"
      }, uri), showCopyUri && uri && _react.default.createElement(_calicoUiKit.CopyToClipboard, {
        content: uri,
        style: {
          marginLeft: '0.15em'
        },
        tooltip: false
      }, _ref2), showCopyCitation && citation && _react.default.createElement(_calicoUiKit.CopyToClipboard, {
        content: citation,
        style: {
          marginLeft: '0.15em'
        },
        tooltip: false
      }, _ref3));
    }
  }]);
  return Citation;
}(_react.default.Component);

Citation.defaultProps = {
  citation: null,
  showCopyUri: false,
  showCopyCitation: true,
  showTitle: true,
  showUri: true,
  title: null,
  tooltip: false,
  uri: 'http://calicolabs.com'
};
var _default = Citation;
exports.default = _default;